// extracted by mini-css-extract-plugin
export default {"l1":"style_l1__GGK2d"};